import * as React from "react";
import { useAuth } from "@/contexts/AuthContext.js";
import { apiFetch } from "@/lib/api.js";

export function VerificationBanner() {
  const { user, refresh } = useAuth();
  const [sending, setSending] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  if (!user || user.emailVerified) return null;

  const resend = async () => {
    setSending(true);
    try {
      await apiFetch("/api/auth/send-verification", { method: "POST" });
      setSent(true);
    } catch {
      // If auth failed, refresh user context in case session expired
      refresh();
    }
    setSending(false);
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2.5 text-sm text-amber-800 flex items-center justify-between">
      <span>Please verify your email address to unlock all features.</span>
      <button onClick={resend} disabled={sending || sent} className="text-amber-900 font-medium hover:underline disabled:opacity-50">
        {sent ? "Email sent!" : sending ? "Sending..." : "Resend verification email"}
      </button>
    </div>
  );
}
